/** Preserve input order while bounding the number of in-flight requests. */
export const mapConcurrently = async <T, R>(
  items: readonly T[],
  concurrency: number,
  map: (item: T) => Promise<R>,
): Promise<R[]> => {
  const results = new Array<R>(items.length);
  let cursor = 0;
  let failed = false;
  const run = async () => {
    while (!failed && cursor < items.length) {
      const index = cursor++;
      try {
        results[index] = await map(items[index]!);
      } catch (error) {
        failed = true;
        throw error;
      }
    }
  };
  const settled = await Promise.allSettled(
    Array.from({ length: Math.min(items.length, Math.max(1, concurrency)) }, run),
  );
  // Drain scheduled work before allowing a retry to start another request batch.
  for (const result of settled) if (result.status === 'rejected') throw result.reason;
  return results;
};
